/* ===== WIP SLIDER + INTERSECTION OBSERVER ===== */

(function() {
  'use strict';

  /* --- Why Wip Slider --- */
  var slider = document.querySelector('.why-wip__slides');
  var prevBtn = document.querySelector('[data-slider-prev]');
  var nextBtn = document.querySelector('[data-slider-next]');

  if (slider && prevBtn && nextBtn) {
    var slides = slider.querySelectorAll('.why-wip__slide');
    var currentSlide = 0;
    var totalSlides = slides.length;

    function goToSlide(index) {
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;
      currentSlide = index;
      slider.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
    }

    nextBtn.addEventListener('click', function() {
      goToSlide(currentSlide + 1);
    });

    prevBtn.addEventListener('click', function() {
      goToSlide(currentSlide - 1);
    });
  }

  /* --- Intersection Observer for scroll animations --- */
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.animate-on-scroll').forEach(function(el) {
    observer.observe(el);
  });

  /* --- Header: hide on scroll down, show on scroll up --- */
  var header = document.querySelector('.header');
  if (header) {
    var lastScrollY = 0;
    var ticking = false;

    function onScroll() {
      var currentY = window.scrollY;

      if (currentY <= 10) {
        /* At top — default position, no scrolled state */
        header.classList.remove('scrolled');
        header.classList.remove('header--hidden');
      } else if (currentY > lastScrollY && currentY > 80) {
        /* Scrolling down past 80px — hide */
        header.classList.add('scrolled');
        header.classList.add('header--hidden');
      } else if (currentY < lastScrollY) {
        /* Scrolling up — show */
        header.classList.add('scrolled');
        header.classList.remove('header--hidden');
      }

      lastScrollY = currentY;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  }

  /* --- Mobile drawer --- */
  var hamburger = document.querySelector('.header__hamburger');
  var drawer = document.querySelector('.header__drawer');
  var drawerClose = document.querySelector('.header__drawer-close');

  if (hamburger && drawer) {
    hamburger.addEventListener('click', function() {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    if (drawerClose) {
      drawerClose.addEventListener('click', function() {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }

    // Close drawer when any link inside it is clicked
    drawer.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }
})();
